import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container d-flex flex-column flex-md-row gap-3 align-items-start" }

import { onMounted } from 'vue'

  // Components
  import Navbar from './Navbar.vue'
  import MobileHeader from './MobileHeader.vue'

  // Store
  import { useStore } from '@/store'
  import Cookies from 'js-cookie'

  // Config
  import { CookieName } from '@/config/cookies'

  // Composables
  import { useHeaderFooter } from '@/composables/useHeaderFooter'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

  // Vue
  const store = useStore()

  // Utils
  const { injectHeaderAndFooter, removeHeaderAndFooter, needToRefetch } =
    useHeaderFooter()

  onMounted(async () => {
    // If needToRefetch, remove the current header and footer, inject the new one
    if (needToRefetch) {
      removeHeaderAndFooter()
      injectHeaderAndFooter(
        window.env.VUE_APP_MENU_DOMAIN,
        store.getters.getLocale,
        Cookies.get(CookieName.COMPANY)
      )
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MobileHeader, { class: "d-block d-md-none" }),
    _createVNode(Navbar),
    _createVNode(_component_router_view)
  ]))
}
}

})